import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "onChange", "value", "defaultValue", "hideLabel", "label", "openCalendarDropdownAriaLabel", "clearDatePickerAriaLabel", "error", "defaultOpen", "isDisabled", "calendarAriaLabel", "nextMonthAriaLabel", "portalElement", "previousMonthAriaLabel"];
import { jsx, jsxs } from 'react/jsx-runtime';
import { Calendar, XMark } from '@box/blueprint-web-assets/icons/Fill';
import { Gray65, Size4 } from '@box/blueprint-web-assets/tokens/tokens';
import * as RadixPopover from '@radix-ui/react-popover';
import clsx from 'clsx';
import { forwardRef, useState, useEffect, useRef, useCallback } from 'react';
import { DatePicker as DatePicker$1, Group, DateInput, DateSegment, Button } from 'react-aria-components';
import { Calendar as Calendar$1 } from '../primitives/calendar/calendar.js';
import '@internationalized/date';
import { IconButton } from '../primitives/icon-button/icon-button.js';
import { InlineError } from '../primitives/inline-error/inline-error.js';
import { useUniqueId } from '../utils/useUniqueId.js';
import { useLabelable } from '../util-components/labelable/useLabelable.js';
import styles from './date-picker.module.js';

var XMarkIcon = function XMarkIcon(label) {
  return function () {
    return jsx(XMark, {
      "aria-label": label,
      color: Gray65,
      height: Size4,
      width: Size4
    });
  };
};

var handleSubmitKeyPress = function handleSubmitKeyPress(key, callback) {
  var submitKeys = [' ', 'Enter'];

  if (submitKeys.includes(key)) {
    callback();
  }
};

var DatePicker = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var className = props.className,
      onChange = props.onChange,
      value = props.value,
      defaultValue = props.defaultValue,
      _props$hideLabel = props.hideLabel,
      hideLabel = _props$hideLabel === void 0 ? false : _props$hideLabel,
      label = props.label,
      openCalendarDropdownAriaLabel = props.openCalendarDropdownAriaLabel,
      clearDatePickerAriaLabel = props.clearDatePickerAriaLabel,
      error = props.error,
      _props$defaultOpen = props.defaultOpen,
      defaultOpen = _props$defaultOpen === void 0 ? false : _props$defaultOpen,
      isDisabled = props.isDisabled,
      calendarAriaLabel = props.calendarAriaLabel,
      nextMonthAriaLabel = props.nextMonthAriaLabel,
      portalElement = props.portalElement,
      previousMonthAriaLabel = props.previousMonthAriaLabel,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      internalValue = _useState2[0],
      setInternalValue = _useState2[1];

  useEffect(function () {
    if (value !== undefined) {
      setInternalValue(value);
    }
  }, [value]);

  var _useState3 = useState(defaultOpen),
      _useState4 = _slicedToArray(_useState3, 2),
      isCalendarOpen = _useState4[0],
      setIsCalendarOpen = _useState4[1];

  var firstDateSegmentRef = useRef(null);
  var calendarButtonRef = useRef(null);
  var shouldFocusStayInInput = useRef(false);
  var onDatePickerValueChanged = useCallback(function (newValue) {
    onChange === null || onChange === void 0 ? void 0 : onChange(newValue);

    if (value === undefined) {
      setInternalValue(newValue);
    }
  }, [onChange, value]);
  var onClearInputButtonClicked = useCallback(function () {
    var _firstDateSegmentRef$;

    onChange === null || onChange === void 0 ? void 0 : onChange(null);

    if (value === undefined) {
      setInternalValue(null);
    }

    (_firstDateSegmentRef$ = firstDateSegmentRef.current) === null || _firstDateSegmentRef$ === void 0 ? void 0 : _firstDateSegmentRef$.focus();
  }, [onChange, value]);
  var onCalendarDateSelect = useCallback(function () {
    setIsCalendarOpen(false);
  }, []);
  var onInputWhiteSpaceClick = useCallback(function () {
    setIsCalendarOpen(true);
    shouldFocusStayInInput.current = true;
  }, []);
  var onDateSegmentClick = useCallback(function () {
    setIsCalendarOpen(true);
    shouldFocusStayInInput.current = true;
  }, []);
  var onKeyUp = useCallback(function (_ref) {
    var key = _ref.key;
    handleSubmitKeyPress(key, function () {
      var _firstDateSegmentRef$2;

      onClearInputButtonClicked();
      (_firstDateSegmentRef$2 = firstDateSegmentRef.current) === null || _firstDateSegmentRef$2 === void 0 ? void 0 : _firstDateSegmentRef$2.focus();
    });
  }, [onClearInputButtonClicked]);
  var onKeyUpButton = useCallback(function (_ref2) {
    var key = _ref2.key;
    handleSubmitKeyPress(key, function () {
      setIsCalendarOpen(!isCalendarOpen);
      shouldFocusStayInInput.current = false;
    });
  }, [isCalendarOpen]);
  var onPress = useCallback(function () {
    shouldFocusStayInInput.current = false;
  }, []);
  var hasError = !!error && !isDisabled;
  var calendarKey = "".concat(internalValue === null || internalValue === void 0 ? void 0 : internalValue.day, "/").concat(internalValue === null || internalValue === void 0 ? void 0 : internalValue.month, "/").concat(internalValue === null || internalValue === void 0 ? void 0 : internalValue.year).concat(internalValue === null || internalValue === void 0 ? void 0 : internalValue.era);
  var onOpenAutoFocus = useCallback(function (e) {
    if (shouldFocusStayInInput.current) {
      e.preventDefault();
    }
  }, []);
  var onFocusOutside = useCallback(function (e) {
    var wasCalendarButtonPressed = calendarButtonRef.current && calendarButtonRef.current.contains(e.target);

    if (!wasCalendarButtonPressed) {
      e.preventDefault();
    }
  }, []);
  var displayValue = value !== undefined ? value : internalValue;
  var Label = useLabelable(label, '');
  var inlineErrorId = useUniqueId('inline-error-');
  var ariaDescribedBy = clsx(rest['aria-describedby'], _defineProperty({}, inlineErrorId, hasError));
  return jsx(RadixPopover.Root, {
    onOpenChange: setIsCalendarOpen,
    open: isCalendarOpen,
    children: jsxs(DatePicker$1, _objectSpread(_objectSpread({}, rest), {}, {
      ref: forwardedRef,
      "aria-describedby": ariaDescribedBy,
      className: clsx(styles.datePicker, _defineProperty({}, styles.disabled, isDisabled), className),
      isDisabled: isDisabled,
      isInvalid: hasError,
      onChange: onDatePickerValueChanged,
      value: displayValue,
      children: [jsx(Label, {
        className: clsx(styles.label, _defineProperty({}, styles.disabled, isDisabled)),
        hideLabel: hideLabel
      }), jsx(RadixPopover.Anchor, {
        asChild: true,
        children: jsxs(Group, {
          className: clsx(styles.group),
          onClick: onInputWhiteSpaceClick,
          onMouseUp: onDateSegmentClick,
          children: [jsx("div", {
            className: clsx(styles.groupContainer, _defineProperty({}, styles.error, hasError)),
            children: jsx(DateInput, {
              className: clsx(styles.groupContainerInput),
              children: function children(segment) {
                return jsx(DateSegment, {
                  ref: function ref(node) {
                    if (!firstDateSegmentRef.current) {
                      firstDateSegmentRef.current = node;
                    }
                  },
                  className: styles.groupContainerInputSegment,
                  segment: segment
                });
              }
            })
          }), displayValue && jsx(IconButton, {
            "aria-label": clearDatePickerAriaLabel,
            className: clsx(styles.button, styles.clear),
            disabled: isDisabled,
            icon: XMarkIcon(clearDatePickerAriaLabel),
            onClick: onClearInputButtonClicked,
            // onKeyDown overwrites handler which manages arrow navigation within group
            // use onKeyUp instead
            onKeyUp: onKeyUp,
            size: "x-small"
          }), jsx(RadixPopover.Trigger, {
            asChild: true,
            children: jsx(Button, {
              ref: calendarButtonRef,
              "aria-label": openCalendarDropdownAriaLabel,
              className: styles.button,
              isDisabled: isDisabled,
              // onKeyDown breaks arrow navigation within group
              // onPress doesn't work with Popover.Trigger - onKeyUp is the only option
              onKeyUp: onKeyUpButton,
              onPress: onPress,
              children: jsx(Calendar, {
                "aria-label": openCalendarDropdownAriaLabel,
                color: Gray65,
                height: Size4,
                width: Size4
              })
            })
          })]
        })
      }), jsx(RadixPopover.Portal, {
        container: portalElement,
        children: jsx(RadixPopover.Content, {
          align: "start",
          className: styles.datePickerPopoverContent,
          onFocusOutside: onFocusOutside,
          onOpenAutoFocus: onOpenAutoFocus,
          sideOffset: 8,
          children: jsx(Calendar$1, {
            autoFocus: !shouldFocusStayInInput.current,
            calendarAriaLabel: calendarAriaLabel,
            isDateUnavailable: rest.isDateUnavailable,
            isDisabled: isDisabled,
            isInvalid: rest.isInvalid,
            isReadOnly: rest.isReadOnly,
            maxValue: rest.maxValue,
            minValue: rest.minValue,
            nextMonthAriaLabel: nextMonthAriaLabel,
            onChange: onCalendarDateSelect,
            previousMonthAriaLabel: previousMonthAriaLabel,
            value: displayValue
          }, calendarKey)
        })
      }), jsx(InlineError, {
        className: styles.inlineError,
        id: inlineErrorId,
        children: error
      })]
    }))
  });
});
DatePicker.displayName = 'DatePicker';
export { DatePicker };